module.exports = __webpack_public_path__ + "img/church_walk_b2.6b7ef1d2.jpg";